import {
    AfterViewChecked,
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    NgZone, OnChanges,
    OnDestroy,
    OnInit,
    Output,
    Renderer2, SimpleChanges,
    ViewChild,
    ViewChildren
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import 'rxjs/add/operator/takeWhile';

import {BufferGraphService} from 'app/buffer-graph/services/buffer-graph.service';
import {CommonDataService} from 'app/services/common-data.service';
import {GraphData} from 'app/buffer-graph/models/graph-data';
import {CompareItem} from 'app/buffer-graph/models/compare-item';
import {ChartData} from 'app/buffer-graph/models/chart-data';
import {Size} from 'app/shared/models/size';
import {ResizeDirection} from 'app/resize-glyph/resize-glyph.component';
import {ITabInfo} from 'app/buffer-graph/models/tab-info-interface';
import {ItemOrderHistoryTabInfo} from 'app/buffer-graph/models/item-order-history/item-order-history-tab-info';
import {ItemOrderHistory} from 'app/buffer-graph/models/item-order-history/item-order-history';
import {ItemOrderHistoryFresh} from 'app/buffer-graph/models/item-order-history/item-order-history-fresh';
import {BufferChangeHistory} from 'app/buffer-graph/models/buffer-change-history/buffer-change-history';
import {BufferChangeHistoryTabInfo} from 'app/buffer-graph/models/buffer-change-history/buffer-change-history-tab-info';
import {ItemActionsTabInfo} from 'app/buffer-graph/models/item-actions/item-actions-tab-info';
import {ItemAction} from 'app/buffer-graph/models/item-actions/item-action';
import {FreshItemActionHeader} from 'app/buffer-graph/models/item-actions/fresh-item-action-header';
import {BufferChangeReasonsTabInfo} from 'app/buffer-graph/models/buffer-change-reasons/buffer-change-reasons-tab-info';
import {SuppliersSchedulesTabInfo} from 'app/buffer-graph/models/suppliers-schedules/suppliers-schedules-tab-info';
import {AssortmentStructureTabInfo} from 'app/buffer-graph/models/assortment-structure/assortment-structure-tab-info';
import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as moment from "moment";
import {Moment} from "moment";
import * as fileSaver from 'file-saver';
import {ISubscription} from "rxjs/Subscription";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {ChartGetDataModel, ChartSetDataModel} from "../../models/amchart/chart-exchange";
import {AddChartModel} from "../../models/amchart/add-chart-model";
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {ChartDataTabInfo} from "../../models/chart-data/chart-data-tab-info";
import {Amchart4Component} from "../amchart4.component/amchart4.component";
import {ItemOrderHistoryComponent} from "../item-order-history.component/item-order-history.component";
import {BufferChangeHistoryComponent} from "../buffer-change-history.component/buffer-change-history.component";
import {ItemActionsComponent} from "../item-actions.component/item-actions.component";
import {BufferChangeReasonsComponent} from "../buffer-change-reasons.component/buffer-change-reasons.component";
import {SuppliersSchedulesComponent} from "../suppliers-schedules.component/suppliers-schedules.component";
import {ChartDataComponent} from "../chart-data.component/chart-data.component";
import {AssortmentStructureComponent} from "../assortment-structure.component/assortment-structure.component";
import {CodeNameChartTabs} from "../../models/code-name-chart-tabs";
import {PeriodSelectorModel} from "../../../shared/models/period-selector-model";
import {BufferChangeReason} from "../../models/buffer-change-reasons/buffer-change-reason";
import {TabDataGUID} from 'app/buffer-graph/models/tab-data-GUID';
import {TabsModeGUID} from "../../models/tabs-mode-GUID";
import {ChartDataGUID} from "../../models/chart-data-GUID";
import {ChartPeriodSelectorComponent} from "../chart-period-selector.component/chart-period-selector.component";
import * as Popper from 'popper.js/dist/umd/popper';
import {ChartListProps} from "../../models/amchart/chart-list-props";
import {StocksFilter} from "../../../stocks/models/stocks-filter";
import {SimpleTabInfo} from "../../models/simple-tab/simple-tab-info";
import {TabItem} from "../../models/tab-item";
import {CommonService} from "../../../services/common.service";
import {ChartDataRow} from "../../models/chart-data-row";
import {Versions} from "../../../shared/models/vesions";
import {ChartVisibilityGUID} from "../../models/chart-visibility-GUID";
import {BGChartType} from "../../models/b-g-chart-type";
import {CodeNameSummaryChart} from "../../../stocks/models/code-name";
import Timer = NodeJS.Timer;
import ScrollEvent = JQuery.ScrollEvent;
import {GraphAutoMakeOptions} from "../../models/graph-auto-make-options";
import {TabsListComponent} from "../tabs-list.component/tabs-list.component";

am4core.useTheme(am4themes_animated);

type History = ItemOrderHistory | ItemOrderHistoryFresh;
type Action = ItemAction | FreshItemActionHeader;

export enum ActivateTab {
    ManualSelection = 1,
    AutoSelect = 2
}

@Component({
    selector: 'buffer-graph',
    templateUrl: './buffer-graph.component.html',
    styleUrls: ['../../styles/common-chart.css', './buffer-graph.component.css']
})

export class BufferGraphComponent implements OnInit, AfterViewChecked, AfterViewInit, OnDestroy, OnChanges{
    constructor(private readonly translateService: TranslateService, private readonly graphService: BufferGraphService,
                private readonly commonData: CommonDataService, private readonly renderer: Renderer2,
                private readonly zone: NgZone, private readonly dataExchange: BufferGraphDataExchangeService,
                private readonly commonService: CommonService){
        this.showErrors = new EventEmitter<{ errors: string[], isOnInitiating: boolean }>();
        this._showLoadingImg = false;
        // this.loadApiError = new EventEmitter<void>();
        this.closeInfo = new EventEmitter<boolean>();
        this.changeBuffer = new EventEmitter<void>();
        this.outerDisplayModeOutput = new EventEmitter<boolean>();
        this.resizeValueWidth = 0;
        this.resizeValueHeight = 0;
        // this.chartsHeightCoeff = 1;
        this.tabHeaders = [];
        this.simpleTab = [];
        this.twoTablesTab = [];
        this.treeTab = [];
        this.tabs = {};
        this.iohStatuses = {};
        this.iohFulfillment = {};
        this.iohNewMover = {};
        this.helper = new ChartHelper();
        this.compareChartArr = [];
        this.height = 1000;
        this.tabsViewMode = false;
        this.tabsDisplayMode = false;
        this._chartWidth = null;
        this.compareItems = [];
        this.hideCompareBtn = true;

        try{
            this.tabsWidthCoeff = this.hideChart ? {
                tw: 100,
                cw: 0
            } : JSON.parse(localStorage['BgChartsWidthCoeff']) || {tw: 50, cw: 50};
        } catch (e){
            this.tabsWidthCoeff = this.hideChart ? {tw: 100, cw: 0} : {tw: 50, cw: 50};
        }

        this.firstSyncModes = true;
        this.hideChart = true;

        this.setChartsHeight();
    }

    @ViewChild('mainChart')
    private mainChartComponent: Amchart4Component;

    @ViewChild('mainChart', {read: ElementRef})
    private mainChartRef: ElementRef;

    @ViewChild('compareChart')
    private compareChartComponent: Amchart4Component;

    @ViewChild('compareChart', {read: ElementRef})
    private compareChartRef: ElementRef;

    @ViewChild('tabsContainer')
    private tabsRef: ElementRef;

    @ViewChild('tabsContainerHor')
    private tabsRefHor: ElementRef;

    @ViewChild('tabsListBtn')
    private tabsListBtn: ElementRef;

    @ViewChild('charts')
    private chartsRef: ElementRef;

    @ViewChild('mainWrp')
    private mainWrp: ElementRef;

    @ViewChild('tabsList')
    private tabsList: TabsListComponent;

    @ViewChild('tabsHeaderWrp')
    private tabsHeaderWrp: ElementRef;

    @ViewChild('tabsHeaderWrpHor')
    private tabsHeaderWrpHor: ElementRef;

    //in func
    @ViewChild('showCompBtn')
    private showCompBtn: ElementRef;

    @ViewChild('tabsListBtnHdr')
    private tabsListBtnHdr: ElementRef;

    @ViewChild('wrhListBtn')
    public wrhListBtn: ElementRef;

    @ViewChild('customListAnchor')
    private customListAnchor: ElementRef;

    //in func
    @ViewChild('customListsWrp')
    private customListsWrp: ElementRef;

    //in func
    @ViewChild('customListBtn')
    private customListBtn: ElementRef;

    @ViewChild('tabsWrp')
    private tabsWrp: ElementRef;

    //in func
    @ViewChild('btnWrpCompare')
    private btnWrpCompare: ElementRef;

    @ViewChild('vSplitterTab', {read: ElementRef})
    private vSplitterTabRef: ElementRef;

    @ViewChild('vSplitterCharts', {read: ElementRef})
    private vSplitterChartsRef: ElementRef;

    @ViewChild('horizontalTabs')
    private horizontalTabsRef: ElementRef;

    //in func
    @ViewChild('chartPeriodSelector')
    private chartPeriodSelector: ChartPeriodSelectorComponent;

    @ViewChild('IOH')
    private IOH: ItemOrderHistoryComponent;

    @ViewChild('BCH')
    private BCH: BufferChangeHistoryComponent;

    @ViewChild('IA')
    private IA: ItemActionsComponent;

    @ViewChild('BCR')
    private BCR: BufferChangeReasonsComponent;

    @ViewChild('SSS')
    private SSS: SuppliersSchedulesComponent;

    @ViewChild('AST')
    private AST: AssortmentStructureComponent;

    @ViewChild('CD')
    private CD: ChartDataComponent;

    @ViewChildren('tabsEl')
    private tabsEls: any[];

    @Input()
    private set itemId(val: number){
        this._itemId = val;
    };

    private get itemId(): number{
        return this._itemId
    }

    @Input() private dateStart: Moment;
    @Input() private dateEnd: Moment;
    @Input() public isAdmin: boolean;
    @Input() public type: BGChartType;
    @Input() public itemIds?: number[];
    @Input() public options?: GraphAutoMakeOptions;

    @Input()
    public set updateChartSize(val: number){
        //val ? this.chartWidth = val * this.tabsWidthCoeff.cw / 100 : null;
    };

    @Input() public sharedGUID?: string;

    @Input() public mainChartData?: ChartData;
    @Input() public outerDisplayMode?: boolean;

    @Output() private readonly showErrors: EventEmitter<{ errors: string[], isOnInitiating?: boolean }>;
    @Output() private readonly outerDisplayModeOutput: EventEmitter<boolean>;

    //TODO: display error message on modal
    //@Output() private loadApiError: EventEmitter<void>;

    @Output() private readonly changeBuffer: EventEmitter<void>;

    @Output() private readonly closeInfo: EventEmitter<boolean>;

    public get verticalDirection(): ResizeDirection{
        return ResizeDirection.Vertical;
    }

    public get horizontalDirection(): ResizeDirection{
        return ResizeDirection.Horizontal;
    }

    public get tabManualSelection(): ActivateTab{
        return ActivateTab.ManualSelection;
    }

    public get itemOrderHistoryTabId(): string{
        return ItemOrderHistoryTabInfo.id;
    }

    public get bufferChangeHistoryTabId(): string{
        return BufferChangeHistoryTabInfo.id;
    }

    public get itemActionsTabId(): string{
        return ItemActionsTabInfo.id;
    }

    public get bufferChangeReasonsTabId(): string{
        return BufferChangeReasonsTabInfo.id;
    }

    public get suppliersSchedulesTabId(): string{
        return SuppliersSchedulesTabInfo.id;
    }

    public get assortmentStructureTabId(): string{
        return AssortmentStructureTabInfo.id;
    }

    public get chartDataTabId(): string{
        return ChartDataTabInfo.id;
    }


    public set showLoadingImg(val: boolean){
        if (val){
            this._showLoadingImg = val;
        } else if (!val && !this.tabsLoading){
            this._showLoadingImg = val;
        }
    }

    public get showLoadingImg(): boolean{
        return this._showLoadingImg;
    }

    public get chartWidth(): number{
        return this._chartWidth;
    }

    public set chartWidth(val: number){
        this.helper.wait(() => this._chartWidth = val);
    }

    public get chartType(): typeof BGChartType{
        return BGChartType;
    }

    private destroyed: boolean;
    private daysCount: number;
    //private dateStart: Moment;
    //private dateEnd: Moment;
    //private shown: boolean;
    //private temporaryHidden: boolean;
    public cwhItemId: number;

    public compareItems: CompareItem[];
    private compareChartData: ChartData;
    private resizeTimerWidth: any;
    private resizeTimerHeight: any;
    private resizeValueWidth: number;
    private resizeValueHeight: number;
    public compareChartArr: AddChartModel[];
    // private chartsHeightCoeff: number;
    public tabsWidthCoeff: { tw: number, cw: number };
    public tabsHeightCoeff: { th: number, ch: number };
    private chartsTemplateRows: string;
    private showTargetLevel: boolean;
    public isTabsVisible: boolean;
    public bodyTemplateColumns: string;
    private subscriptionNewGraphData: ISubscription;
    private subscriptionAddChartToCompare: ISubscription;
    private subscriptionToggleTabs: ISubscription;
    private subscriptionUpdateChartData: ISubscription;
    private subscriptionToggleChartInfo: ISubscription;
    private subscriptionUpdateCustomChartPopper: ISubscription;
    private subscriptionChartVisibility: ISubscription;
    private subscriptionToggleBubbleChart: ISubscription;
    private subscriptionOpenTabs: ISubscription;
    public readonly tabHeaders: ITabInfo[];
    public readonly simpleTab: ITabInfo[];
    public readonly twoTablesTab: ITabInfo[];
    public readonly treeTab: ITabInfo[];
    public readonly tabs: { [header: string]: ITabInfo };
    private readonly iohStatuses: { [index: number]: string };
    private readonly iohFulfillment: { [index: number]: string };
    private readonly iohNewMover: { [index: number]: string };
    public readonly helper: ChartHelper;
    private _showLoadingImg: boolean;
    public tabsViewMode: boolean;
    public tabsDisplayMode: boolean;
    public btnTopDisplayMode: string;
    private interval: Timer;
    public skipSubscription: boolean;
    public showTabsList: boolean;
    public showTabsListHor: boolean;
    public showTabsListHdr: boolean;
    public _chartWidth: number;
    public tabsLoading: boolean;
    public showCustomLists: boolean;
    public hideCompareBtn: boolean;
    public compareButtonsPopperUpdate: boolean;
    private compareButtonsPopper: Popper;
    public addItemGUID: string;
    public showInfo: boolean;
    private customListsPopperCreate: boolean;
    private customListsPopper: Popper;
    public showWrhList: boolean;
    public _itemId: number;
    public tabsNeedUpdate: boolean;
    private listenMouseDownAddChart: () => void;
    public loadingText: string;
    public lastActiveTabId: string;
    public versionNotCompatible: boolean;
    private scrollListenerTabsContainer: () => void;
    private scrollListenerTabsContainerHor: () => void;
    private init: boolean;
    private viewInit: boolean;
    private firstSyncModes: boolean;
    public showChartButtonTitle: string;
    public bubbleVisible: boolean;
    public summaryData: {codes: CodeNameSummaryChart[], wrhCnt: number, skuCnt: number};
    public set hideChart(val: boolean){
        // console.trace(val, 'hideChart')
        this._hideChart = val;
    }

    public get hideChart(): boolean{
        return this._hideChart
    }
    public _hideChart: boolean;

    public GUID: string;
    private height: number;

    @HostListener('document:resize', ['$event'])
    private onResize = (): void =>{
        this.compareButtonsPopperUpdate = true;
    }

    async ngOnInit(){

        let hideChartGuid = this.dataExchange.getChartVisibility(this.sharedGUID);
        if (hideChartGuid){
            this.hideChart = hideChartGuid.hideChart;
        } else {
            this.hideChart = false;
        }

        this.setLoadingText(false);

        try{
            let res = await this.commonService.getVersionPermission('Chart', new Versions().chart).toPromise();
            // console.log(res, 'res')
            this.isAdmin = res.isAdmin;
            this.versionNotCompatible = !(res && res.success);
        } catch (e){
            this.versionNotCompatible = true;
        }

        this.translateService.get(['ArrivedInTime', 'ComeLate', 'OrderNotFulfilled', 'InTransit', 'InTransitLate',
            'OrderCanceled', 'NoData', 'OrderBlocked', 'ArrivedMore', 'ArrivedLess', 'ArrivedFullQuantity', 'NoMOA', 'NoMOQ','NoMOAMOQ',
            'NoMOW', 'NoMOAMOW', 'NoMOQMOW', 'NoMOQMOWMOA', 'BufferCorrection', 'NewMover', 'Manual_Type', 'Order', 'ArrivedMore',
            'OrderBocked_NorReachPoint', 'Stocks_NotDistributed'])
            .subscribe(t =>{
                this.iohStatuses[1] = t.ArrivedInTime;
                this.iohStatuses[2] = t.ComeLate;
                this.iohStatuses[3] = t.OrderNotFulfilled;
                this.iohStatuses[4] = t.InTransit;
                this.iohStatuses[5] = t.InTransitLate;
                this.iohStatuses[6] = t.OrderCanceled;
                this.iohStatuses[7] = t.NoData;
                this.iohStatuses[8] = t.OrderBlocked;
                this.iohStatuses[9] = t.NoMOA;
                this.iohStatuses[10] = t.NoMOQ;
                this.iohStatuses[11] = t.NoMOAMOQ;
                this.iohStatuses[12] = t.NoMOW;
                this.iohStatuses[13] = t.NoMOAMOW;
                this.iohStatuses[14] = t.NoMOQMOW;
                this.iohStatuses[15] = t.NoMOQMOWMOA;
                this.iohStatuses[16] = t.OrderBocked_NorReachPoint;
                this.iohStatuses[17] = t.Stocks_NotDistributed;

                this.iohFulfillment[1] = t.ArrivedMore;
                this.iohFulfillment[2] = t.ArrivedLess;
                this.iohFulfillment[3] = t.ArrivedFullQuantity;
                this.iohFulfillment[4] = `${t.Manual_Type} ${this.helper.lowerCaseFirstLetter(t.Order)}. ${t.ArrivedMore}`;

                this.iohNewMover[0] = '';
                this.iohNewMover[1] = t.NewMover;
                this.iohNewMover[2] = t.BufferCorrection;
            });

        this.showChartButtonTitle = this.type === BGChartType.Summary ? 'StocksDescShowSummaryChart' : 'StocksDescShowMainChart'


        !this.sharedGUID ? this.sharedGUID = this.helper.generateGUID() : null;

        !this.GUID ? this.GUID = this.sharedGUID : null;

        if (this.type === BGChartType.Main || this.type === BGChartType.Summary){
            this.dataExchange.setToggleChartInfo({type: this.type, sharedGUID: this.sharedGUID, show: true});
        }

        await this.getCompareData();

        //# get saved data for tabs from service
        await this.getDataFromService();

        this.addItemGUID = this.helper.generateGUID();

        //# git chart data if not ca in current
        !this.mainChartData ? await this.getGraphData(this.GUID, this.type, this.type === BGChartType.Summary? this.itemIds : this.itemId, this.dateStart, this.dateEnd, this.onReceived) : this.addToListProps(this.addItemGUID);

        //# update chart data when we change period in chart
        this.subscriptionNewGraphData = this.dataExchange.newChartDataCurrent.subscribe((r: ChartGetDataModel) =>{
            this.helper.tryCatch(() => {
                if (r && r.type === this.type && r.sharedGUID === this.sharedGUID){
                    console.log(r, r.GUID, r.sharedGUID, 'subscriptionNewGraphData')
                    if (r.typeCluster === BGChartType.All){
                        this.getGraphData(r.GUID, r.type, r.itemId, moment.utc(r.startDate), moment.utc(r.endDate), this.onReceived);
                        this.getCompareData();
                        this.compareChartArr && this.compareChartArr.length
                        && this.getGraphData(
                            this.compareChartArr[0].GUID,
                            r.type,
                            this.compareChartArr[0].itemId,
                            moment.utc(r.startDate),
                            moment.utc(r.endDate),
                            this.onReceivedCompared
                        );
                    } else if (r.typeCluster === BGChartType.MainChart){
                        this.getGraphData(r.GUID, r.type, r.itemId, moment.utc(r.startDate), moment.utc(r.endDate), this.onReceived);
                        this.getCompareData();
                        if (this.itemId !== r.itemId && this.compareChartArr.length){
                            this.onCloseCompareChart();
                        }
                    } else if (r.typeCluster === BGChartType.CompareChart) {
                        this.getGraphData(this.compareChartArr[0].GUID, r.type, this.compareChartArr[0].itemId, moment.utc(r.startDate), moment.utc(r.endDate), this.onReceivedCompared);
                    }
                }
            })
        });

        //# update update tabs after update chart
        this.subscriptionUpdateChartData = this.dataExchange.updateChartDataCurrent.subscribe(r =>
            this.helper.tryCatch(() =>{
                this.updateTabs(r)
            })

        );

        //# add or update compare chart
        this.subscriptionAddChartToCompare = this.dataExchange.addCompareChartCurrent.subscribe((r: AddChartModel) =>
            this.helper.tryCatch(() => {
                if (r && r.type === this.type){
                    if (this.compareChartArr.length){
                        this.compareChartArr = [];
                    }
                    this.compareChartArr.push(r);
                    this.getGraphData(r.GUID, r.type, r.itemId, moment.utc(r.startDate), moment.utc(r.endDate), this.onReceivedCompared);
                }
            })
        );

        //# update list of tabs, close no need, open needed
        this.subscriptionOpenTabs = this.dataExchange.tabsListCurrent.subscribe((r: CodeNameChartTabs[]) =>
            this.helper.tryCatch(() => {
                let found = r.find(t => t.GUID === this.GUID);
                if (found && this.options && this.options.openTabs.length && !this.options.initiatedTabList){
                    this.options.initiatedTabList = true;

                    this.tabsList.data.tabs.forEach(tab =>
                        this.options.openTabs.forEach(ot => {
                            if (tab.key === ot){
                                tab.selected = true;
                                this.tabsList.data.selected.push(tab);
                            }
                        } ));
                    if (this.tabsList.data.selected.length){
                        this.tabsList.apply('Apply');
                        this.options.hideChart && this.toggleChartVisibility();
                    } else {
                        this.showTabsListHdr = false;
                    }

                }
            })
        );

        //# update list of tabs, close no need, open needed
        this.subscriptionToggleTabs = this.dataExchange.tabsListGUIDCurrent.subscribe((r: string) =>
            this.helper.tryCatch(() =>
                r && r === this.GUID
                    ? this.skipSubscription
                        ? this.skipSubscription = false
                        : this.toggleTabs()
                    : null


                // this.skipSubscription
                //     ? this.skipSubscription = false
                //     : r && r.length
                //         ? this.toggleTabs()
                //         : null
            )
        );

        //# toggle show chart infoPanel
        this.subscriptionToggleChartInfo = this.dataExchange.toggleChartInfoCurrent.subscribe((r: { type: BGChartType, sharedGUID: string, show: boolean }) =>
            this.helper.tryCatch(() => {
                r && (this.type === r.type || this.sharedGUID === r.sharedGUID) ? this.showInfo = r.show : null
                // console.log(this.showInfo, 'subscriptionToggleChartInfo, bgcomponent')
            })
        );

        //# update compare poppers
        this.subscriptionUpdateCustomChartPopper = this.dataExchange.customChartPopperUpdateCurrent.subscribe(r =>
            this.helper.tryCatch(() => r && this.customListsPopper ? this.popperUpd() : null)
        );

        //# update chart visibility
        this.subscriptionChartVisibility = this.dataExchange.chartVisibilityCurrent.subscribe(r =>
            this.helper.tryCatch(() => {
                let visibility = this.dataExchange.getChartVisibility(this.sharedGUID);
                if (r && visibility){
                    this.hideChart = visibility.hideChart;
                }
            })
        );

        //# toggle visibility bubble chart for main and compare chart
        this.subscriptionToggleBubbleChart = this.dataExchange.toggleBubbleChartCurrent.subscribe((r: { type: BGChartType, sharedGUID: string, show: boolean }) =>
            this.helper.tryCatch(() =>{
                if (r && (this.type === r.type || this.sharedGUID === r.sharedGUID)){
                    this.bubbleVisible = r.show;
                }
            })
        );

        this.listenMouseDownAddChart = this.renderer.listen('body', 'mousedown', (e: MouseEvent) =>{
            this.hideAddChart(e);
            this.hideAddCompareChartBtns(e)
        });

        if (this.options){
            if (this.options.openTabs.length > 0){
                this.helper.wait(() => this.showTabsListHdr = true);
            }
        }

        this.init = true;
    }

    ngAfterViewInit(): void{
        this.helper.wait(this.setChartsWidth);
        //# update tabs headers width in single tab mode view
        this.interval = setInterval(() =>{
            let tabsHeaderWrp = this.tabsDisplayMode ? this.tabsHeaderWrpHor : this.tabsHeaderWrp;
            if (tabsHeaderWrp && tabsHeaderWrp.nativeElement){
                let tabs = tabsHeaderWrp.nativeElement.children;
                let tabsWrp = tabsHeaderWrp.nativeElement;
                let fullWidth: number = 0;
                this.helper.forEachHtml((tab) =>{
                    this.renderer.setStyle(tab, 'width', 'auto');
                    fullWidth += tab.offsetWidth
                }, tabs);

                if (fullWidth > tabsWrp.offsetWidth){

                    this.helper.forEachHtml((tab, i, tabs) =>{
                        this.renderer.setStyle(tab, 'width', `calc(${100 / tabs.length}% - 1px)`);
                    }, tabs);
                }
            }
        }, 1000);

        this.chartWidth = this.mainWrp.nativeElement.offsetWidth;

        this.comparePopperAdd();

        this.viewInit = true;

        this.scrollListenerTabsContainer = this.renderer.listen(this.tabsRef.nativeElement, 'scroll', (e: ScrollEvent) =>{
            this.dataExchange.setHideDropdown({GUID: this.sharedGUID});
        });

        this.scrollListenerTabsContainerHor = this.renderer.listen(this.tabsRefHor.nativeElement, 'scroll', (e: ScrollEvent) =>{
            this.dataExchange.setHideDropdown({GUID: this.sharedGUID});
        });


    }

    ngAfterViewChecked(): void{
        if (this.customListsPopperCreate){
            this.customListsPopperCreate = false;
            this.popperAdd();
        }

        if (this.compareButtonsPopperUpdate){
            this.compareButtonsPopperUpdate = false;
            this.compareButtonsPopper ? this.compareButtonsPopper.update() : null;
        }

        if (this.init && this.viewInit && this.firstSyncModes){
            this.firstSyncModes = false;
            this.syncModes();
        }

    }

    ngOnChanges(changes: SimpleChanges){
        if (changes['updateChartSize']){
            if (changes['updateChartSize'].currentValue !== changes['updateChartSize'].previousValue){
                let val =  changes['updateChartSize'].currentValue;
                val ? this.chartWidth = val * this.tabsWidthCoeff.cw / 100 : null;
            }
        }
    }

    ngOnDestroy(): void{
        this.destroyed = true;
        this.dataExchange.setNewChartData(null);
        this.subscriptionNewGraphData.unsubscribe();
        this.subscriptionAddChartToCompare.unsubscribe();
        this.subscriptionToggleTabs.unsubscribe();
        this.subscriptionUpdateChartData.unsubscribe();
        this.subscriptionToggleChartInfo.unsubscribe();
        this.subscriptionUpdateCustomChartPopper.unsubscribe();
        this.subscriptionToggleBubbleChart.unsubscribe();
        this.subscriptionOpenTabs.unsubscribe();
        this.dataExchange.setAddChart(null);
        clearInterval(this.interval);
        this.interval = null;
        this.listenMouseDownAddChart();
        this.scrollListenerTabsContainer();
        this.scrollListenerTabsContainerHor();
        if (this.type !== BGChartType.Info){
            this.dataExchange.delTabsData(this.sharedGUID);
            this.dataExchange.delTabsMode(this.sharedGUID);
            this.dataExchange.delChartData(this.sharedGUID);
        }

        if (this.options){
            this.options.initiatedTabList = false;
        }

        // this.dataExchange.setAddChart(null);

    }

    public readonly isCompareChartShown = (): boolean => {
        return  this.compareChartArr.length && this.compareChartArr[0].data && !this.tabsDisplayMode && !this.hideChart
    }

    private setLoadingText = (loadTabs: boolean): void =>{
        // console.log(loadTabs, 'loadTabs', this.hideChart, 'this.hideChart' ,'setLoadingText')
        if (!this.hideChart && loadTabs){
            this.loadingText = 'Tables_AndChart_Building'
        } else if (!this.hideChart) {
            this.loadingText = 'Chart_Building'
        } else {
            this.loadingText = 'Tables_Building'
        }
    }

    //# get data for tabs and chart if it was previously saved (if type info)
    private getDataFromService = async (): Promise<void> =>{
        let tabsModeGUID: TabsModeGUID = this.dataExchange.getTabsMode(this.sharedGUID);
        if (tabsModeGUID){
            this.tabsDisplayMode = tabsModeGUID.tabsDisplayMode;
            this.tabsViewMode = tabsModeGUID.tabsViewMode;
            // this.hideChart = tabsModeGUID.hideChart;
            this.setChartsWidth();
            this.setChartsHeight();
        }

        let chartHideGuid = this.dataExchange.getChartVisibility(this.sharedGUID);

        if (chartHideGuid){
            this.hideChart = chartHideGuid.hideChart;
        }

        let chartData = this.dataExchange.getChartData(this.sharedGUID, this.itemId);

        if (chartData){
            this.mainChartData = chartData.data;
        }

        let tabsData = this.dataExchange.getTabsData(this.sharedGUID, this.itemId);

        // console.log(tabsData, 'getDataFromService')

        if (tabsData){
            tabsData.data.forEach(item => this.tabHeaders.push(item));
        }
        for (let i = 0; i < this.tabHeaders.length; i++){

            this.tabs[this.tabHeaders[i].id] = this.tabHeaders[i];
            //await this.syncTabs(this.tabHeaders[i], false);
        }
        this.tabHeaders.length ? this.setTabsVisibility(true) : null;
        await this.toggleTabs();

    }

    //# get list of warehouses where this SKU presents and itemId of this SKU on central warehouse
    private readonly getCompareData = async (): Promise<void> => {
        let data = await this.graphService.getCompareData(this.itemId).toPromise()
            if (data == null || data.accessDenied)
                return;

            this.cwhItemId = data.cwhItemId;
            this.compareItems = data.items;
    }

    //# when chart was data loading, function which apply data, for main chart
    private onReceived = (data: GraphData, GUID: string, summaryData: {codes: CodeNameSummaryChart[], wrhCnt: number, skuCnt: number}): void =>{
        //this.initiated = true;
        this.itemId = data.chartData.itemInfo.itemId;
        if (this.mainChartData){
            this.mainChartData = data.chartData;
            this.dataExchange.setUpdateChartData(new ChartSetDataModel(GUID, this.type, data.chartData, summaryData));
        }
        // console.log(summaryData, 'onReceived')
        this.mainChartData = data.chartData;
        this.summaryData = summaryData;
        this.dataExchange.setChartData(new ChartDataGUID(this.GUID, data.chartData, summaryData));
        this.addToListProps(this.addItemGUID);
        // this.removeAllTabs(false);
        // this.helper.wait(() => this.toggleTabs(), 10);

    };

    //# when chart was data loading, function which apply data, for compare chart
    private onReceivedCompared = (data: GraphData, GUID: string): void =>{
        this.showLoadingImg = false;
        let chart = this.compareChartArr.find(item => item.GUID === GUID);

        if (!chart){
            return;
        }

        // console.log(this.tabsDisplayMode, 'onReceivedCompared tabs display mode')
        // console.log(chart.data, 'onReceivedCompared tabs display mode')

        if (chart.data){
            // console.log('chart')

            this.dataExchange.setUpdateChartData(new ChartSetDataModel(GUID, this.type, data.chartData, null));
        }

        if (this.tabsDisplayMode){
            // console.log('onReceivedCompared toggle tabs display mode')
            this.toggleTabDisplayMode();
            // this.removeAllTabs();
        }

        chart.data = data.chartData;

        // if (this.chartsHeightCoeff === 1){
        //     this.chartsHeightCoeff = 0.6;
        // }
        this.setChartsHeight();
        this.setChartsWidth();

        // let mainChartData = this.mainChartData;
        //
        // this.mainChartData = null;


        this.helper.wait(() =>{
            this.dataExchange.setToggleBubbleChart({type: this.type, sharedGUID: this.sharedGUID, show: false});
            this.dataExchange.setToggleChartInfo({type: this.type, sharedGUID: this.sharedGUID, show: false});
        }, 3000);

        this.helper.wait(() =>{

            // this.mainChartData = mainChartData;
        }, 15000);


        // } else {
        //
        // }

    };

    //# get chart data with dependency injection
    private getGraphData = async (
        GUID: string, type: BGChartType,
        itemIds: number | number[],
        dateStart: Moment,
        dateEnd: Moment,
        onDataReceived: (data: GraphData, GUID: string, summary?: {codes: CodeNameSummaryChart[], wrhCnt: number, skuCnt: number}) => void
    ): Promise<void> =>{
        this.showLoadingImg = true;

        try{
            let data: { accessDenied: boolean, graphData: GraphData, skuWrhValues: CodeNameSummaryChart[], wrhCnt: number, skuCnt: number } = type === BGChartType.Summary
                ? await this.graphService.getSummaryBufferGraphData(itemIds as number[], dateStart, dateEnd).toPromise()
                : await this.graphService.getBufferGraphData(itemIds as number, dateStart, dateEnd).toPromise();

            // console.log(GUID, itemIds, data, 'getGraphData bufferGraph');
            if (data == null || data.accessDenied){
                //this.showLoadingImg = false;
                this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'GetBufferGraphDataError')
                    .subscribe(error => this.showErrors.emit({
                        errors: [error],
                        isOnInitiating: this.mainChartData == null
                    }));
                return;
            }

            onDataReceived(data.graphData, GUID, data.skuWrhValues ? {codes: data.skuWrhValues, wrhCnt: data.wrhCnt, skuCnt: data.skuCnt} : null);

        } catch (e){
            this.helper.showError(e, () => this.showErrors.emit({errors: [e.message || e], isOnInitiating: this.mainChartData == null}));
        }


    }


    //# toggle tabs visibility
    private setTabsVisibility = (visible: boolean): void =>{
        this.isTabsVisible = visible;
        this.setChartsWidth();
        this.setChartsHeight();
        this.chartWidth = Math.random() * 1000;
        this.syncModes();
    }

    //# show current tab, or set headers active if view mode
    public activateTab = (tabInfo?: ITabInfo, activateTab?: ActivateTab): void =>{
        if (this.tabsViewMode){
            tabInfo ? tabInfo.isActive = true : null;
            return;
        }

        if (activateTab === ActivateTab.ManualSelection){
            this.lastActiveTabId = tabInfo.id;
        }

        if (tabInfo && this.lastActiveTabId && (!activateTab || activateTab !== ActivateTab.ManualSelection)){
            this.tabHeaders.some(t => t.isActive = t.id === this.lastActiveTabId);
        } else if (tabInfo || this.tabHeaders.every(t => !t.isActive)){
            this.tabHeaders.forEach((t, i) => t.isActive = t === tabInfo || (tabInfo == null && i === this.tabHeaders.length - 1));
        }

    }

    //# remove tab and sync it with tabs list
    public removeTab = (tabInfo: ITabInfo, sync: boolean = false, closeInfo: boolean = false): void =>{
        const idx = this.tabHeaders.indexOf(tabInfo);
        if (idx < 0)
            return;

        this.tabs[this.tabHeaders[idx].id] ? delete this.tabs[this.tabHeaders[idx].id] : null;

        this.tabHeaders[idx].id === this.lastActiveTabId ? this.lastActiveTabId = '' : null;

        this.tabHeaders.splice(idx, 1);

        this.tabHeaders.length === 0 ? this.setTabsVisibility(false) : this.activateTab();

        this.dataExchange.setTabsData(new TabDataGUID(this.sharedGUID, this.tabHeaders));

        this.updateUniversalTabs();

        if (sync){
            let data = this.dataExchange.getTabsList(this.GUID);
            if (data){
                data.tabs.forEach(item => tabInfo.id === item.code ? item.selected = false : null);
                data.selected.forEach((item, i, arr) => tabInfo.id === item.code ? arr.splice(i, 1) : null);
                this.skipSubscription = true;
                this.dataExchange.setTabsList(data);
            }
        }

        if (this.tabsViewMode){
            this.dataExchange.notifyTabsResize(this.sharedGUID)
        }

        if (!this.tabHeaders.length && this.type === BGChartType.Info && this.hideChart && closeInfo){
            this.closeInfo.emit(true);
        }


        // this.setChartsHeight();
        // this.setChartsWidth();
    }

    //# remove all tabs and sync them with tabs list
    public removeAllTabs = (sync: boolean = true): void =>{
        // this.tabHeaders.forEach(item => this.removeTab(item));
        this.tabHeaders.forEach((item, i) => delete this.tabs[this.tabHeaders[i].id]);

        this.tabHeaders.length = 0;


        this.setTabsVisibility(false);
        this.dataExchange.setTabsData(new TabDataGUID(this.sharedGUID, this.tabHeaders));

        this.updateUniversalTabs();

        if (!sync){
            return
        }

        this.lastActiveTabId = '';
        let data = this.dataExchange.getTabsList(this.GUID);
        if (data){
            data.tabs.forEach(item => item.selected = false);
            data.selected.length = 0;
            this.skipSubscription = true;
            this.dataExchange.setTabsList(data);
        }
    }

    //# update list of tabs, close no need, open needed
    public toggleTabs = async (): Promise<void> =>{
        const data = this.dataExchange.getTabsList(this.GUID);
        // console.log(this.tabsLoading, this.tabsNeedUpdate, data, 'toggleTabs')

        if (this.tabsLoading){
            this.tabsNeedUpdate = true;
        }

        // console.log(this.dataExchange.getTabsList2(), 'toggleTabs')
        // console.log(data, this.tabsLoading , 'tabsLoading', this.tabsNeedUpdate, 'tabsNeedUpdate')
        if (!data || this.tabsLoading){
            return;
        }

        let idx: number[] = [];
        this.tabHeaders.forEach((item, i) =>{
            let remove: boolean = !data.selected.some(inItem => item.id === inItem.code);
            remove && idx.push(i);
        })

        idx.reverse();
        idx.forEach(item => this.removeTab(this.tabHeaders[item]));

        this.tabsNeedUpdate = this.tabHeaders.some(th => th.itemInfo.itemId !== this.itemId);

        if (!!data.viewMode !== this.tabsViewMode){
            this.toggleTabViewMode()
        }

        if (data.selected.length){
            this.setLoadingText(true);
        }

        this.tabsLoading = true;

        try{
            for (let i = 0; i < data.selected.length; i++){
                let item = data.selected[i],
                    add: boolean = !this.tabHeaders.some(inItem => item.code === inItem.id);

                if (add){
                    await this.addTabByType(item)
                }

                if (this.tabsNeedUpdate){
                    this.tabsNeedUpdate = false;
                    this.tabsLoading = false;
                    this.removeAllTabs(false);
                    this.helper.wait(this.toggleTabs, 10);
                    return;
                }
            }
        } catch (e){

        }

        this.updateUniversalTabs();

        this.helper.wait(() =>{
            this.dataExchange.notifyTabsResize(this.sharedGUID);
            this.tabsLoading = false;
            this.showLoadingImg = false;
            this.dataExchange.updateChartDimensions(this.sharedGUID);

        }, 1000);

        this.helper.wait(() =>{
            this.mapOrder(this.tabHeaders, data.selected.filter(i => i).map(item => item.code), 'id')
        }, 5)
    }

    //# sync tabs with tabs list
    private syncTabs = async (tabInfo: ITabInfo, syncData: boolean = true): Promise<void> =>{
        let tabList = await this.getTabList();

        tabList.tabs.forEach(item =>{
            if (item.code === tabInfo.id){
                item.selected = true;
            }
        });

        if (tabList.selected.findIndex(item => item.code === tabInfo.id) === -1){
            let tab = tabList.tabs.find(item => item.code === tabInfo.id);
            tabList.selected.push(tab);
        }

        this.skipSubscription = true;
        this.dataExchange.setTabsList(tabList);
        syncData ? this.dataExchange.setTabsData(new TabDataGUID(this.sharedGUID, this.tabHeaders)) : null;
    }

    //# get tab list saved in service, or load it from server
    private getTabList = async (): Promise<CodeNameChartTabs> =>{
        let tabList = this.dataExchange.getTabsList(this.GUID);
        if (!tabList){
            tabList = await this.helper.getDefaultTabsList(this.GUID, this.translateService, this.graphService, this.commonData, this.type);
        }
        return tabList;
    }

    //# sort one array like other
    private mapOrder = (array: any[], order: any[], key: string): void =>{

        array.sort(function (a, b){
            let A = a[key], B = b[key];

            if (order.indexOf(A) > order.indexOf(B)){
                return 1;
            } else{
                return -1;
            }

        });

        //return array;
    };

    //# show tab ItemOrderHistory
    private showItemOrderHistory = async (tabIn: TabItem): Promise<void> =>{
        await this.loadItemOrderHistoryData(async data =>{
                console.log(data, 'loadItemOrderHistoryData END')
                const tab = new ItemOrderHistoryTabInfo(
                    'OrderHistory',
                    tabIn.zoomFilterField,
                    {
                        isFresh: data.isFresh,
                        sku: data.sku,
                        warehouseCode: data.warehouseCode,
                        orders: data.orders,
                        canSend: data.canSend,
                        columns: data.columns,
                        columnsLine: data.columnsLine
                    },
                    this.mainChartData.itemInfo,
                    this.mainChartData.startDate,
                    this.mainChartData.endDate,
                    this.sharedGUID
                );
                tab.viewMode = this.tabsViewMode;
                tab.displayMode = this.tabsDisplayMode;
                this.tabHeaders.push(tab);
                this.updateUniversalTabs();
                this.tabs[this.itemOrderHistoryTabId] = tab;
                this.activateTab(tab);
                if (this.tabHeaders.length === 1){
                    this.setTabsVisibility(true);
                }
                await this.syncTabs(tab);

            }, this.mainChartData.startDate.format(),
            this.mainChartData.endDate.format()
        );
    }

    //# load data for tab ItemOrderHistory
    private loadItemOrderHistoryData = async (onLoaded: (data: {
        accessDenied: boolean, isFresh: boolean, sku: string, warehouseCode: string,
        orders: History[], canSend: boolean, columns: ColumnSettingsBase[], columnsLine: ColumnSettingsBase[] }) => void, startDate: string, endDate: string): Promise<void> =>{
        this.showLoadingImg = true;

        let data;

        console.log(this.itemId, moment.utc(startDate).format('DD.MM.YYYY'), moment.utc(endDate).format('DD.MM.YYYY'), 'loadItemOrderHistoryData Start')

        try{
            data = await this.graphService.getItemOrderHistory(
                this.itemId,
                this.iohStatuses,
                this.iohFulfillment,
                this.iohNewMover,
                'Stocks',
                'ItemOrderHistory',
                this.translateService.currentLang,
                startDate,
                endDate
            ).toPromise();
        } catch (e){
            this.showLoadingImg = false;
            this.helper.showError(e, () => this.showErrors.emit({errors: [e.message || e]}));
            return;
        }

        if (data == null || data.accessDenied){
            this.showLoadingImg = false;
            this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'GetOrderHistoryError')
                .subscribe(error => this.showErrors.emit({errors: [error]}));
            return;
        }

        await onLoaded(data);
        this.helper.wait(() => this.showLoadingImg = false)
    }

    //# show tab BufferChangeHistory
    private showBufferChangeHistory = async (tabIn: TabItem): Promise<void> =>{
        await this.loadBufferChangeHistoryData(async data =>{
                console.log(data, 'loadBufferChangeHistoryData END')
                const tab = new BufferChangeHistoryTabInfo(
                    'BufferChangeHistory',
                    {
                        changes: data.changes,
                        sku: data.sku,
                        warehouseCode: data.warehouseCode,
                        canSend: data.canSend,
                        columns: data.columns
                    },
                    this.mainChartData.itemInfo,
                    this.mainChartData.startDate,
                    this.mainChartData.endDate,
                    this.sharedGUID
                );
                tab.viewMode = this.tabsViewMode;
                tab.displayMode = this.tabsDisplayMode;
                this.tabHeaders.push(tab);
                this.updateUniversalTabs();
                this.tabs[this.bufferChangeHistoryTabId] = tab;
                this.activateTab(tab);
                if (this.tabHeaders.length === 1){
                    this.setTabsVisibility(true);
                }

                await this.syncTabs(tab);
            },
            this.mainChartData.startDate.format(),
            this.mainChartData.endDate.format()
        );
    }

    //# load data for tab BufferChangeHistoryData
    private loadBufferChangeHistoryData = async (onLoaded: (data: { accessDenied: boolean, changes: BufferChangeHistory[], sku: string, warehouseCode: string, canSend: boolean, columns: ColumnSettingsBase[] }) => void, startDate: string, endDate: string): Promise<void> =>{
        this.showLoadingImg = true;
        let data;

        console.log(this.itemId, moment.utc(startDate).format('DD.MM.YYYY'), moment.utc(endDate).format('DD.MM.YYYY'), 'loadBufferChangeHistoryData Start')
        try{
            data = await this.graphService.getBufferChangeHistory(
                this.itemId,
                'Stocks',
                'BufferChangeHistory',
                this.translateService.currentLang,
                startDate,
                endDate
            ).toPromise();
            console.log(data, 'loadBufferChangeHistoryData')
        } catch (e){
            this.showLoadingImg = false;
            this.helper.showError(e, () => this.showErrors.emit({errors: [e.message || e]}));
            return;
        }

        if (data == null || data.accessDenied){
            this.showLoadingImg = false;
            this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'GetBufferChangeHistoryError')
                .subscribe(error => this.showErrors.emit({errors: [error]}));
            return;
        }

        await onLoaded(data);
        this.helper.wait(() => this.showLoadingImg = false)



    }

    //# show tab ItemActions
    private showItemActions = async (tabIn: TabItem): Promise<void> =>{
        await this.loadItemActionsData(async data =>{
                console.log(data, 'loadItemActionsData END')
                const tab = new ItemActionsTabInfo(
                    'Actions',
                    tabIn.zoomFilterField,
                    {
                        actions: data.actions,
                        isFresh: data.isFresh,
                        sku: data.sku,
                        warehouseCode: data.warehouseCode,
                        canSend: data.canSend,
                        columns: data.columns,
                        columnsLine: data.columnsLine
                    },
                    this.mainChartData.itemInfo,
                    this.mainChartData.startDate,
                    this.mainChartData.endDate,
                    this.sharedGUID
                );
                tab.viewMode = this.tabsViewMode;
                tab.displayMode = this.tabsDisplayMode;
                this.tabHeaders.push(tab);
                this.updateUniversalTabs();
                this.tabs[this.itemActionsTabId] = tab;
                this.activateTab(tab);
                if (this.tabHeaders.length === 1){
                    this.setTabsVisibility(true);
                }
                await this.syncTabs(tab);

            }, this.mainChartData.startDate.utc().format(),
            this.mainChartData.endDate.utc().format()
        );
    }

    //# load data for tab ItemActionsData
    private loadItemActionsData = async (onLoaded: (data: { accessDenied: boolean, isFresh: boolean, actions: Action[], sku: string, warehouseCode: string, canSend: boolean, columns: ColumnSettingsBase[], columnsLine: ColumnSettingsBase[] }) => void, startDate: string, endDate: string): Promise<void> =>{
        this.showLoadingImg = true;
        console.log(this.itemId, moment.utc(startDate).format('DD.MM.YYYY'), moment.utc(endDate).format('DD.MM.YYYY'), 'loadItemActionsData Start')
        let data;
        try{
            data = await this.graphService.getItemActions(
                this.itemId,
                'Stocks',
                'ActionHistory',
                'ActionHistoryLine',
                this.translateService.currentLang,
                startDate,
                endDate
            ).toPromise();
        } catch (e){
            this.showLoadingImg = false;
            this.helper.showError(e, () => this.showErrors.emit({errors: [e.message || e]}));
            return;
        }

        if (data == null || data.accessDenied){
            this.showLoadingImg = false;
            this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'GetActionsError')
                .subscribe(error => this.showErrors.emit({errors: [error]}));
            return;
        }
        await onLoaded(data);
        this.helper.wait(() => this.showLoadingImg = false);

    }

    //# show tab BufferChangeReasons
    private showBufferChangeReasons = async (tabIn: TabItem): Promise<void> =>{
        await this.loadBufferChangeReasons(async data =>{
                console.log(data, 'loadBufferChangeReasons END')
                let resCanSend = await this.graphService.canSend().toPromise();
                const tab = new BufferChangeReasonsTabInfo(
                    'BufferChangeReasons',
                    tabIn.zoomFilterField,
                    {
                        reasons: data.reasons,
                        startDate: this.mainChartData.startDate,
                        endDate: this.mainChartData.endDate,
                        canSend: resCanSend.canSend,
                        columns: data.columns
                    },
                    this.mainChartData.itemInfo,
                    this.mainChartData.startDate,
                    this.mainChartData.endDate,
                    this.sharedGUID
                );
                tab.viewMode = this.tabsViewMode;
                tab.displayMode = this.tabsDisplayMode;
                this.tabHeaders.push(tab);
                this.updateUniversalTabs();
                this.tabs[this.bufferChangeReasonsTabId] = tab;
                this.activateTab(tab);
                if (this.tabHeaders.length === 1){
                    this.setTabsVisibility(true);
                }
                await this.syncTabs(tab);

            }, this.mainChartData.startDate.utc().format(),
            this.mainChartData.endDate.utc().format()
        )
    }

    //# load data for tab BufferChangeReasons
    private loadBufferChangeReasons = async (onLoaded: (data: { accessDenied: boolean, reasons: BufferChangeReason[], columns: ColumnSettingsBase[] }) => void, startDate: string, endDate: string): Promise<void> =>{
        this.showLoadingImg = true;

        let data;

        console.log(this.itemId, moment.utc(startDate).format('DD.MM.YYYY'), moment.utc(endDate).format('DD.MM.YYYY'), 'loadBufferChangeReasons Start')

        /*let results = await Promise.all([
            this.graphService.canSend().toPromise(),
            this.graphService.getBufferChangeReasons(this.itemId, 'Stocks', 'BufferChangeReasons', startDate, endDate).toPromise()
        ]);

        console.log(results, 'results')*/

        try{
            data = await this.graphService.getBufferChangeReasons(
                this.itemId,
                'Stocks',
                'BufferChangeReasons',
                this.translateService.currentLang,
                startDate,
                endDate
            ).toPromise();
        } catch (e){
            this.showLoadingImg = false;
            this.helper.showError(e, () => this.showErrors.emit({errors: [e.message || e]}));
            return;
        }

        if (data == null || data.accessDenied){
            this.showLoadingImg = false;
            this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'GetBufferChangeReasonsError')
                .subscribe(error => this.showErrors.emit({errors: [error]}));
            return;
        }

        await onLoaded(data);

        this.helper.wait(() => this.showLoadingImg = false);
    }

    //# load data and show tab SuppliersSchedules
    private showSuppliersSchedules = async (tabIn: TabItem): Promise<void> =>{
        this.showLoadingImg = true;

        let data;

        console.log(this.itemId, 'showSuppliersSchedules Start')

        try{
            data = await this.graphService.getSuppliersSchedules(
                this.itemId,
                'Stocks',
                'SuppliersSchedules',
                this.translateService.currentLang
            ).toPromise();
        } catch (e){
            this.showLoadingImg = false;
            this.helper.showError(e, () => this.showErrors.emit({errors: [e.message || e]}));
            return;
        }

        let resCanSend = await this.graphService.canSend().toPromise();

        if (data == null || data.accessDenied){
            this.showLoadingImg = false;
            this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'GetSuppliersSchedulesError')
                .subscribe(error => this.showErrors.emit({errors: [error]}));
            return;
        }

        console.log(data, 'getSuppliersSchedules END')

        const tab = new SuppliersSchedulesTabInfo(
            'SuppliersSchedules',
            {schedules: data.schedules, canSend: resCanSend.canSend, columns: data.columns},
            this.mainChartData.itemInfo,
            this.mainChartData.startDate,
            this.mainChartData.endDate,
            this.sharedGUID
        );
        tab.viewMode = this.tabsViewMode;
        tab.displayMode = this.tabsDisplayMode;
        this.tabHeaders.push(tab);
        this.updateUniversalTabs();
        this.tabs[this.suppliersSchedulesTabId] = tab;
        this.activateTab(tab);
        if (this.tabHeaders.length === 1){
            this.setTabsVisibility(true);
        }
        await this.syncTabs(tab);

        this.helper.wait(() => this.showLoadingImg = false);

    }

    //# show tab ChartData
    private showChartData = async (tabIn: TabItem): Promise<void> =>{
        await this.loadChartData(async data =>{
                console.log(data, 'loadChartData END')
                let resCanSend = await this.graphService.canSend().toPromise();
                const tab = new ChartDataTabInfo(
                    this.type === BGChartType.Summary ? 'ChartDataSum' :'ChartData',
                    tabIn.zoomFilterField,
                    'ChartData',
                    {
                        chartData: data.chartData,
                        canSend: resCanSend.canSend,
                        columns: data.columns
                    },
                    this.mainChartData.itemInfo,
                    this.mainChartData.startDate,
                    this.mainChartData.endDate,
                    this.sharedGUID
                );
                tab.viewMode = this.tabsViewMode;
                tab.displayMode = this.tabsDisplayMode;
                this.tabHeaders.push(tab);
                this.updateUniversalTabs();
                this.tabs[this.chartDataTabId] = tab;
                this.activateTab(tab);
                if (this.tabHeaders.length === 1){
                    this.setTabsVisibility(true);
                }
                await this.syncTabs(tab);
                this.showLoadingImg = false;

            }, this.mainChartData.startDate.utc().format(),
            this.mainChartData.endDate.utc().format()
        )

    }

    //# load data for tab ChartData
    private loadChartData = async (onLoaded: (data: { chartData: ChartDataRow[], columns: ColumnSettingsBase[] }) => void, startDate: string, endDate: string): Promise<void> =>{
        this.showLoadingImg = true;
        const translates = await this.translateService.get(['Yes', 'No']).toPromise(),
            columnsChart = await this.helper.genChartProps(this.translateService, this.commonService, this.helper.getTypeChart(this.type)),
            columnsBubbleChart = await  this.helper.genBubbleChartProps(this.translateService, this.commonService, this.helper.getTypeChart(this.type)),
            detectBubbleObj = this.helper.arrToObj(columnsBubbleChart.map(item => item.name));
        //let chartData: GraphData = null;

        for (let i = 0; i < columnsChart.length; i++){
            if (columnsChart[i].name === 'actionBuffer'){
                columnsChart[i].lineTranslateKey = 'MainChart_BufferGAll';
            } else if (columnsChart[i].name === 'actionSafetyBuffer'){
                columnsChart[i].lineTranslateKey = 'MainChart_ActionSafetyBufferAll';
            }
        }

        const onDataReceived = async (receivedData: GraphData, GUID: string): Promise<void> =>{
            // console.log(receivedData.chartData.rows, 'receivedData')
            let data = receivedData.chartData.rows.map((item, i) =>{
                    let slickRow: any = {};
                    for (let prop in item){
                        if (detectBubbleObj[prop]){
                            slickRow[prop] = item[prop] ? translates.Yes : translates.No;
                        } else{
                            switch (prop){
                                case 'actionBuffer':
                                    slickRow[prop] = item[prop] - item.bufferG;
                                    break;
                                case 'bufferG':
                                    slickRow[prop] = item.actionBuffer - item.actionSafetyBuffer;
                                    break;
                                case 'bufferY':
                                    slickRow[prop] = item[prop] - item.actionSafetyBuffer;
                                    break;
                                case 'bufferR':
                                    slickRow[prop] = item[prop] - item.actionSafetyBuffer;
                                    break;
                                case 'safetyBuffer':
                                    slickRow[prop] = item.actionSafetyBuffer;
                                    break;
                                case 'actionSafetyBuffer':
                                    slickRow[prop] = item[prop] - item.safetyBuffer;
                                    break;
                                default:
                                    slickRow[prop] = item[prop];
                            }
                            //slickRow[prop] = item[prop]

                        }
                    }
                    //this.helper.getRealBuffer(slickRow);
                    slickRow.id = i + 1;
                    return slickRow;
                });
                // columnsChartSettings = columnsChart.map((item, i) => new ColumnSettingsBase(i + 2, item.name, 'search-number', '', '', 'number', 1, 100, 0)),
                // columnsBubbleChartSettings = columnsBubbleChart.map((item, i) => new ColumnSettingsBase(columnsChartSettings.length + 1, item.name, 'dropdown', '', '', 'boolean', 1, 100, 0)),
                // columnsSettings = columnsChartSettings.concat(columnsBubbleChartSettings);

            // columnsSettings.unshift(new ColumnSettingsBase(1, 'date', 'dropdowndate', 'date', 'Chart_Date', 'date', 1, 100, 0));*/

            // console.log('receivedData 2')
            // let columnsSettings = [];
            let columnsSettings = await this.helper.getChartColumns(this.commonService, this.helper.getTypeChart(this.type));

            // console.log('receivedData 3')

            const keys = this.helper.genKeysForTranslate(columnsChart.concat(columnsBubbleChart));

            columnsSettings.forEach(item =>{
                keys.forEach(inItem =>{
                    if (this.helper.lowerCaseFirstLetter(item.columnName) === inItem.name){
                        item.translateKey = inItem.key
                    }
                })
            });


            await onLoaded({chartData: data, columns: columnsSettings});
            this.helper.wait(() => this.showLoadingImg = false);
        }
        console.log(this.itemId, moment.utc(startDate).format('DD.MM.YYYY'), moment.utc(endDate).format('DD.MM.YYYY'), 'loadChartData Start')
        await onDataReceived({settings: {} as any, chartData: this.mainChartData}, this.sharedGUID);

        // await this.getGraphData('', this.type, this.type === BGChartType.Summary? this.itemIds : this.itemId, moment.utc(startDate), moment.utc(endDate), onDataReceived);
    }

    //# load data and show tab AssortmentStructure
    private showAssortmentStructure = async (tabIn: TabItem): Promise<void> =>{
        this.showLoadingImg = true;
        console.log('AssortmentStructure start')

        try{
            let data = await this.graphService.getAssortmentStructure(this.itemId).toPromise();
            console.log(data, 'AssortmentStructure END')
            if (data == null || data.accessDenied){
                this.showLoadingImg = false;
                this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'GetAssortmentStructureError')
                    .subscribe(error => this.showErrors.emit({errors: [error]}));
                return;
            }

            const tab = new AssortmentStructureTabInfo(
                'AssortmentStructure',
                {states: data.states, balanceStructure: data.balanceStructure},
                this.mainChartData.itemInfo,
                this.mainChartData.startDate,
                this.mainChartData.endDate,
                this.sharedGUID
            );
            tab.viewMode = this.tabsViewMode;
            tab.displayMode = this.tabsDisplayMode;
            this.tabHeaders.push(tab);
            this.updateUniversalTabs();
            this.tabs[this.assortmentStructureTabId] = tab;
            this.activateTab(tab);
            this.updateUniversalTabs();
            if (this.tabHeaders.length === 1){
                this.setTabsVisibility(true);
            }
            await this.syncTabs(tab);
            this.helper.wait(() => this.showLoadingImg = false);
        } catch (e){
            this.showLoadingImg = false;
            this.helper.showError(e, () => this.showErrors.emit({errors: [e.message || e]}));
        }

    }

    //# show tab simple tab
    private showSimpleTab = async (tabIn: TabItem): Promise<void> =>{
        await this.loadSimpleTabData(async data => {
                console.log(tabIn, data, 'loadSimpleTab END')

                let resCanSend = await this.graphService.canSend().toPromise();
                data.rows.forEach((item, i) => item.id = i + 1);
                const tab = new SimpleTabInfo(
                    tabIn.code,
                    tabIn.tabName,
                    tabIn.type,
                    tabIn.zoomFilterField,
                    {
                        rows: data.rows,
                        startDate: this.mainChartData.startDate,
                        endDate: this.mainChartData.endDate,
                        canSend: resCanSend.canSend,
                        columns: data.columns
                    },
                    this.mainChartData.itemInfo,
                    this.mainChartData.startDate,
                    this.mainChartData.endDate,
                    this.sharedGUID
                );
                tab.viewMode = this.tabsViewMode;
                tab.displayMode = this.tabsDisplayMode;
                this.tabHeaders.push(tab);
                this.updateUniversalTabs();
                console.log(this.simpleTab, 'simpleTab')
                this.activateTab(tab);
                if (this.tabHeaders.length === 1){
                    this.setTabsVisibility(true);
                }
                await this.syncTabs(tab);
            },
            tabIn.code,
            tabIn.tabName,
            tabIn.type,
            tabIn.procedure,
            this.mainChartData.startDate.utc().format(),
            this.mainChartData.endDate.utc().format()
        )
    }

    //# load data for tab simple tab
    private loadSimpleTabData = async (onLoaded: (data: { accessDenied: boolean, rows: any[], columns: ColumnSettingsBase[] }) => void, tabId: string, tabName: string, tabType: string, procedure: string, startDate: string, endDate: string): Promise<void> =>{
        this.showLoadingImg = true;

        let data;

        console.log(this.itemId, moment.utc(startDate).format('DD.MM.YYYY'), moment.utc(endDate).format('DD.MM.YYYY'), tabId, 'loadSimpleTab Start')

        /*let results = await Promise.all([
            this.graphService.canSend().toPromise(),
            this.graphService.getBufferChangeReasons(this.itemId, 'Stocks', 'BufferChangeReasons', startDate, endDate).toPromise()
        ]);

        console.log(results, 'results')*/

        try{
            data = this.type === BGChartType.Summary
                ? await this.graphService.getSimpleTabDataSummary(this.itemIds, tabId, tabType, 'Stocks', tabName, procedure, this.translateService.currentLang, startDate, endDate).toPromise()
                : await this.graphService.getSimpleTabData(this.itemId, tabId, tabType, 'Stocks', tabName, procedure, this.translateService.currentLang, startDate, endDate).toPromise()
            // data = await this.graphService.getSimpleTabData(this.itemId, this.iohStatuses, this.iohFulfillment, 'Stocks', 'ItemOrderHistory', startDate, endDate).toPromise();
        } catch (e){
            this.showLoadingImg = false;
            this.helper.showError(e, () => this.showErrors.emit({errors: [e.message || e]}));
            return;
        }

        if (data == null || data.accessDenied){
            this.showLoadingImg = false;
            this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'GetSimpleTabError')
                .subscribe(error => this.showErrors.emit({errors: [error]}));
            return;
        }

        await onLoaded(data);

        this.helper.wait(() => this.showLoadingImg = false);
    }

    /*private onMainChartDrawed = (): void =>{
        if (!this.compareChartData)
            this.showLoadingImg = false;
    }

    private onCompareChartDrawed = (): void =>{
        //if (this.mainChartComponent)
        //this.mainChartComponent.resizeAndRedrawCharts();

        this.showLoadingImg = false;
    }*/

    //# closing compare chart
    public onCloseCompareChart = (): void =>{
        this.compareChartArr = [];
        this.setChartsHeight();
        this.dataExchange.setToggleBubbleChart({type: this.type, sharedGUID: this.sharedGUID, show: true});
        this.dataExchange.setToggleChartInfo({type: this.type, sharedGUID: this.sharedGUID, show: true});

    }

    public setLoading = (e: boolean): void =>{
        this.showLoadingImg = e;
    }

    //# setChart Height and height change mode button
    private setChartsHeight = (): void =>{
        // let coeff: number = this.compareChartArr.length || this.tabsDisplayMode && this.isTabsVisible ? localStorage['BgChartsHeightCoeff'] : 1;
        // let coeff: number;
        if (this.isTabsVisible && this.tabsDisplayMode){
            try{
                this.tabsHeightCoeff = this.hideChart ? {th: 100, ch: 0} : this.helper.getDataFromLS('chartTabsHeightCoeff') || {th: 50, ch: 50};
                // this.tabsHeightCoeff = this.hideChart ? {th: 100, ch: 0} : {th: 50, ch: 50};
            } catch (e){
                this.tabsHeightCoeff = this.hideChart ? {th: 100, ch: 0} : {th: 50, ch: 50};
            }

        } else if (this.compareChartArr.length){
            this.tabsHeightCoeff = this.helper.getDataFromLS('chartTabsHeightCoeff') || {th: 50, ch: 50};
            // this.tabsHeightCoeff =  {th: 50, ch: 50};
        } else {
            this.tabsHeightCoeff = {th: 0, ch: 100};
        }

        this.btnTopDisplayMode = `calc(${100 - this.tabsHeightCoeff.ch}% - 26px - ${(100 - this.tabsHeightCoeff.ch) * 7 /100}px)`;
    }

    //# set chart width
    private setChartsWidth = (): void =>{
        // console.log(this.isTabsVisible, 'this.isTabsVisible', this.tabsDisplayMode, 'this.tabsDisplayMode')
        // this.tabsWidthCoeff = {tw: 49, cw: 50};
        // console.log(this.isTabsVisible, 'setChartsWidth');
        if (this.isTabsVisible && this.tabsDisplayMode){

            this.tabsWidthCoeff.tw = 0;
            this.tabsWidthCoeff.cw = 100;
        } else if (this.isTabsVisible && !this.tabsDisplayMode){

            try{
                this.tabsWidthCoeff = this.hideChart ? {
                    tw: 100,
                    cw: 0
                } : JSON.parse(localStorage['BgChartsWidthCoeff']) || {tw: 50, cw: 50};
            } catch{
                this.tabsWidthCoeff = this.hideChart ? {tw: 100, cw: 0} : {tw: 50, cw: 50};
            }
        } else{
            // console.log('ELSE setChartsWidth')
            this.tabsWidthCoeff.tw = 0;
            this.tabsWidthCoeff.cw = 100;
        }
        // console.log(this.tabsWidthCoeff, 'setChartsWidth');

        //this.bodyTemplateColumns = coeff;
    }

    //# resize main chart height, and tab or compare chart height
    /*private onChartsResizedBy = (size: Size): void =>{
        if (this.resizeTimerHeight)
            clearTimeout(this.resizeTimerHeight);

        this.resizeValueHeight += size.height;

        this.resizeTimerHeight = setTimeout(() =>{
                this.resizeTimerHeight = null;

                const mainHeight = this.mainChartRef.nativeElement.offsetHeight;
                const compareHeight = this.tabsDisplayMode ? this.tabsRef.nativeElement.offsetHeight : this.compareChartRef.nativeElement.offsetHeight;

                this.chartsHeightCoeff = (mainHeight - this.resizeValueHeight) / (mainHeight + compareHeight);
                if (this.chartsHeightCoeff < 0)
                    this.chartsHeightCoeff = 0;
                else if (this.chartsHeightCoeff > 1)
                    this.chartsHeightCoeff = 1;

                localStorage['BgChartsHeightCoeff'] = this.chartsHeightCoeff;
                this.setChartsHeight();

                this.tabsDisplayMode ? this.helper.wait(() => this.dataExchange.notifyTabsResize(this.sharedGUID), 5) : null;

                this.resizeValueHeight = 0;
            },
            250);
    }*/


    //# change height of chart
    public onVerticalResizedBy = (size: Size, tabs: number): void =>{



        if (this.resizeTimerHeight){
            return;
            // clearTimeout(this.resizeTimerHeight);
            // this.resizeTimerHeight = null;
        }

        this.dataExchange.setGlass({sharedGUID: this.sharedGUID, showGlass: true});

        this.resizeTimerHeight = setTimeout(() =>{
                clearTimeout(this.resizeTimerHeight);
                this.resizeTimerHeight = null;

                let rect = tabs === 1
                    ? this.vSplitterTabRef.nativeElement.getBoundingClientRect()
                    : this.vSplitterChartsRef.nativeElement.getBoundingClientRect();
                let mouseMove: MouseEvent = this.commonService.getMouseMove();

                this.resizeValueHeight = tabs * (mouseMove.clientY - rect.y);

                let tabsHeight = !this.isTabsVisible || this.isTabsVisible && !this.tabsDisplayMode
                    ? this.compareChartRef.nativeElement.offsetHeight
                    : this.horizontalTabsRef.nativeElement.offsetHeight;
                let chartHeight = this.mainChartRef.nativeElement.offsetHeight;
                const vResizeWrpHeight = this.chartsRef.nativeElement.offsetHeight;
                const diff = vResizeWrpHeight - (chartHeight + tabsHeight + 5);
                if (diff > 1 || diff < -1){
                    tabsHeight += diff * (tabsHeight - 5) / vResizeWrpHeight;
                    chartHeight += diff * (chartHeight - 5) / vResizeWrpHeight;
                }

                let th = (tabsHeight + this.resizeValueHeight - 5) * 100 / vResizeWrpHeight,
                    ch = (chartHeight - this.resizeValueHeight) * 100 / vResizeWrpHeight,
                    minTablesHeight = 220;
                // minTablesHeight = this.columnsParameters.length ? 325 : 250;

                if (th * vResizeWrpHeight / 100 < 200){
                    this.tabsHeightCoeff.th = (200 / vResizeWrpHeight) * 100;
                    this.tabsHeightCoeff.ch = ((vResizeWrpHeight - 200 - 5) / vResizeWrpHeight) * 100;
                } else if (ch * vResizeWrpHeight / 100 < minTablesHeight){
                    this.tabsHeightCoeff.ch = (minTablesHeight / vResizeWrpHeight) * 100;
                    this.tabsHeightCoeff.th = ((vResizeWrpHeight - minTablesHeight - 5) / vResizeWrpHeight) * 100;
                } else{
                    this.tabsHeightCoeff.th = th;
                    this.tabsHeightCoeff.ch = ch;
                }

                // this.infoTabHeight = this.tabsHeightCoeff.th / 100 * vResizeWrpHeight;

                // this.updateStyles = true;
                // this.resizeGrid = true;

                // console.log(this.tabsHeightCoeff, 'tabsHeightCoeff')
                localStorage['chartTabsHeightCoeff'] = JSON.stringify(this.tabsHeightCoeff);

                this.setChartsHeight();

                this.dataExchange.setGlass({sharedGUID: this.sharedGUID, showGlass: false});
                this.tabsDisplayMode ? this.helper.wait(() => this.dataExchange.notifyTabsResize(this.sharedGUID), 5) : null;


                // this.setChartsWidth();

                // this.helper.wait(this.dataExchange.notifyTabsResize, 5);

                this.resizeValueHeight = 0;

            },
            150);
    }

    //# resize main chart and tab width
    public onTabsResizedBy = (size: Size): void =>{

        this.resizeValueWidth += size.width;

        if (this.resizeTimerWidth){
            // clearTimeout(this.resizeTimerWidth);
            return;
        }

        this.dataExchange.setGlass({sharedGUID: this.sharedGUID, showGlass: true});

        this.resizeTimerWidth = setTimeout(() =>{
                clearTimeout(this.resizeTimerWidth)
                this.resizeTimerWidth = null;

                let chartsWidth = this.chartsRef.nativeElement.offsetWidth;
                let tabsWidth = this.tabsRefHor.nativeElement.offsetWidth;
                const mainWrpWidth = this.mainWrp.nativeElement.offsetWidth;
                const diff = mainWrpWidth - (chartsWidth + tabsWidth + 5);
                if (diff > 1 || diff < -1){
                    tabsWidth += diff * (tabsWidth - 5) / mainWrpWidth;
                    chartsWidth += diff * (chartsWidth - 5) / mainWrpWidth;
                }

                this.tabsWidthCoeff.tw = (tabsWidth + this.resizeValueWidth - 5) * 100 / mainWrpWidth;
                this.tabsWidthCoeff.cw = (chartsWidth - this.resizeValueWidth) * 100 / mainWrpWidth;
                this.chartWidth = this.tabsWidthCoeff.cw / 100 * mainWrpWidth;

                // console.log(this.tabsWidthCoeff, 'this.tabsWidthCoeff')
                /*if (this.chartsWidthCoeff < 0)
                    this.chartsWidthCoeff = 0;
                else if (this.chartsWidthCoeff > 1)
                    this.chartsWidthCoeff = 1;*/

                localStorage['BgChartsWidthCoeff'] = JSON.stringify(this.tabsWidthCoeff);
                // this.setChartsWidth();

                this.dataExchange.setGlass({sharedGUID: this.sharedGUID, showGlass: false});
                this.helper.wait(() => this.dataExchange.notifyTabsResize(this.sharedGUID), 5);


                this.resizeValueWidth = 0;
            },
            300);
    }

    //# add host listener, which listens hotkey for open or close tab
    @HostListener('document:keydown', ['$event'])
    private onModalKeyDown = async (event: KeyboardEvent): Promise<void> =>{
        if (!event.ctrlKey || event.altKey || event.shiftKey || event.repeat){
            return;
        }

        // console.log(this.tabsLoading, 'this.tabsLoading')

        const handled = (): boolean =>{
            event.preventDefault();
            event.stopPropagation();
            return this.tabsLoading;
        }

        //Target level
        if (event.code == 'KeyL'){
            handled();
            this.showTargetLevel = !this.showTargetLevel;
            this.dataExchange.setShowTargetLevel(this.showTargetLevel);
        }

        if (this.type === BGChartType.Info){
            return;
        }

        const findTab = async (code: string): Promise<TabItem> => {
            let tabList = await this.getTabList();
            return tabList.tabs.find(t => t.code === code)

        }


        try{
            switch (event.code){
                case 'KeyT':
                case 'KeyI':
                case 'KeyO':// Item order history
                    if (handled()) return;
                    const iohTab = this.tabs[this.itemOrderHistoryTabId];
                    if (iohTab)
                        this.removeTab(iohTab);
                    else{
                        this.tabsLoading = true;
                        await this.showItemOrderHistory(await findTab('IOH'));
                        this.tabsLoading = false;
                    }
                    return;
                case 'KeyH':// Buffer change history
                    if (handled()) return;
                    const bchTab = this.tabs[this.bufferChangeHistoryTabId];
                    if (bchTab)
                        this.removeTab(bchTab);
                    else{
                        this.tabsLoading = true;
                        let tab = await findTab('IOH');
                        await this.showBufferChangeHistory(await findTab('BCH'));
                        this.tabsLoading = false;
                    }
                    return;
                case 'KeyA':// Item actions
                    if (handled()) return;
                    const iaTab = this.tabs[this.itemActionsTabId];
                    if (iaTab)
                        this.removeTab(iaTab);
                    else{
                        this.tabsLoading = true;
                        await this.showItemActions(await findTab('IA'));
                        this.tabsLoading = false;
                    }
                    return;
                // case 'KeyR':// Buffer change reasons
                    // if (handled()) return;
                    // const bcrTab = this.tabs[this.bufferChangeReasonsTabId];
                    // if (bcrTab)
                    //     this.removeTab(bcrTab);
                    // else{
                    //     this.tabsLoading = true;
                    //     await this.showBufferChangeReasons(await findTab('BCR'));
                    //     this.tabsLoading = false;
                    // }
                    // return;
                case 'KeyS':// Supplier schedule
                    if (handled()) return;
                    const ssTab = this.tabs[this.suppliersSchedulesTabId];
                    if (ssTab)
                        this.removeTab(ssTab);
                    else{
                        this.tabsLoading = true;
                        await this.showSuppliersSchedules(await findTab('SSS'));
                        this.tabsLoading = false;
                    }
                    return;
                case 'KeyG':// Assortment structure
                    if (handled()) return;
                    const asTab = this.tabs[this.assortmentStructureTabId];
                    if (asTab)
                        this.removeTab(asTab);
                    else{
                        this.tabsLoading = true;
                        await this.showAssortmentStructure(await findTab('AST'));
                        this.tabsLoading = false;
                    }
                    return;
                case 'KeyE':// Chart data
                    if (handled()) return;
                    const cdTab = this.tabs[this.chartDataTabId];
                    if (cdTab)
                        this.removeTab(cdTab);
                    else{
                        this.tabsLoading = true;
                        await this.showChartData(await findTab('CD'));
                        this.tabsLoading = false;
                    }
                    return;
            }

            await this.openUniversalTab(event, handled);

        } catch (e){

        }
    }

    //# open or close universal tab by hotkey
    private openUniversalTab = async (event: KeyboardEvent, handled: () => void): Promise<void> => {
        let tabList = await this.getTabList();

        for (let i = 0;  i < tabList.tabs.length; i++){
            if (event.code === tabList.tabs[i].hotKey){
                // console.log(tabList.tabs[i], event.code, 'find hotkey')
                if (handled()) return;
                let tab;
                this.tabHeaders.some(inItem =>{
                    if (tabList.tabs[i].code === inItem.id){
                        tab = inItem;
                        return true;
                    }
                });
                if (tab)
                    this.removeTab(tab);
                else {
                    this.tabsLoading = true;
                    switch (tabList.tabs[i].type){
                        case 'SimpleTab':
                            await this.showSimpleTab(tabList.tabs[i]);
                            break;
                    }
                    this.tabsLoading = false;
                }

            }
        }
    }

    //# add tab by id
    /*public addTab = async (id: string): Promise<void> =>{
        switch (id){
            case 'IOH':// Item order history
                await this.showItemOrderHistory();
                break;
            case 'BCH':// Buffer change history
                await this.showBufferChangeHistory();
                break;
            case 'IA':// Item actions
                await this.showItemActions();
                break;
            case 'BCR':// Buffer change reasons
                await this.showBufferChangeReasons();
                break;
            case 'SSS':// Supplier schedule
                await this.showSuppliersSchedules();
                break;
            case 'AST':// Assortment structure
                await this.showAssortmentStructure();
                break;
            case 'CD':// Chart data
                await this.showChartData();
                break;
            case 'CDS':// Chart data summary
                await this.showChartData();
                break;
        }
    }*/

    //# add tab by type
    private addTabByType = async (tab: TabItem): Promise<void> =>{
        switch (tab.type){
            case 'OrderHistory':// Item order history
                await this.showItemOrderHistory(tab);
                break;
            case 'BufferChangeHistory':// Buffer change history
                await this.showBufferChangeHistory(tab);
                break;
            case 'Actions':// Item actions
                await this.showItemActions(tab);
                break;
            case 'BufferChangeReasons':// Buffer change reasons
                await this.showBufferChangeReasons(tab);
                break;
            case 'OrdersSchedules':// Supplier schedule
                await this.showSuppliersSchedules(tab);
                break;
            case 'AssortmentStructure':// Assortment structure
                await this.showAssortmentStructure(tab);
                break;
            case 'ChartData':// Chart data
                await this.showChartData(tab);
                break;
            case 'SimpleTab':// Chart data
                await this.showSimpleTab(tab);
                break;
        }
    }

    //# show all or current period data for tab ItemOrderHistory
    public onShowAllItemOrderHistory = (dates: PeriodSelectorModel): void =>{
        this.loadItemOrderHistoryData(data =>{
                const tab = (this.tabs[this.itemOrderHistoryTabId] as ItemOrderHistoryTabInfo);
                tab.dateChanged = true;
                // tab.data.isAll = true;
                tab.data.orders = data.orders;
                tab.startDate = moment.utc(dates.startDate);
                tab.endDate = moment.utc(dates.endDate);
            }, dates.startDate,
            dates.endDate
        );
    }

    //# show all or current period data for tab  BufferChangeHistory
    public onShowAllBufferChangeHistory = (dates: PeriodSelectorModel): void =>{
        this.loadBufferChangeHistoryData(data =>{
                const tab = (this.tabs[this.bufferChangeHistoryTabId] as BufferChangeHistoryTabInfo);
                tab.dateChanged = true;
                // tab.data.isAll = true;
                tab.data.changes = data.changes;
                tab.startDate = moment.utc(dates.startDate);
                tab.endDate = moment.utc(dates.endDate);
            }, dates.startDate,
            dates.endDate
        );
    }

    //# show all or current period data for tab BufferChangeReasons
    public onShowBufferChangeReasons = (dates: PeriodSelectorModel): void =>{
        this.loadBufferChangeReasons(data =>{
                const tab = (this.tabs[this.bufferChangeReasonsTabId] as BufferChangeReasonsTabInfo);
                tab.dateChanged = true;
                // tab.data.isAll = true;
                tab.data.reasons = data.reasons;
                tab.startDate = moment.utc(dates.startDate);
                tab.endDate = moment.utc(dates.endDate);
            }, dates.startDate,
            dates.endDate
        );
    }

    //# show all or current period data for tab ItemActions
    public onShowItemActions = (dates: PeriodSelectorModel): void =>{
        this.loadItemActionsData(data =>{
                const tab = (this.tabs[this.itemActionsTabId] as ItemActionsTabInfo);
                tab.dateChanged = true;
                // tab.data.isAll = true;
                tab.data.actions = data.actions;
                tab.startDate = moment.utc(dates.startDate);
                tab.endDate = moment.utc(dates.endDate);
            }, dates.startDate,
            dates.endDate
        );
    }

    //# show all or current period data for tab ChartData
    public onShowChartData = (dates: PeriodSelectorModel): void =>{
        this.loadChartData(data =>{
                const tab = (this.tabs[this.chartDataTabId] as ChartDataTabInfo);
                tab.dateChanged = true;
                // tab.data.isAll = true;
                tab.data.chartData = data.chartData;
                tab.startDate = moment.utc(dates.startDate);
                tab.endDate = moment.utc(dates.endDate);
                this.showLoadingImg = false;
            }, dates.startDate,
            dates.endDate
        );
    }

    private onChangeBufferClick = (): void =>{
        this.changeBuffer.emit();
    }

    //# change tabs view mode
    public toggleTabViewMode = (tabId?: string): void =>{
        // console.trace(tabId, 'toggleTabViewMode')
        this.tabsViewMode = !this.tabsViewMode;
        let tabList = this.dataExchange.getTabsList(this.GUID);
        tabList.viewMode = this.tabsViewMode ? 1 : 0;
        this.skipSubscription = true;
        this.dataExchange.setTabsList(tabList);


        // console.log(this.tabs, 'this.tabs');
        // console.log(this.tabsViewMode, tabId, 'this.tabsViewMode, tabId');

        this.tabHeaders.forEach(item => {
            if (!this.tabsViewMode && tabId && item.id === tabId){
                item.isActive = true;
            } else{
                item.isActive = this.tabsViewMode;
            }
            item.viewMode = this.tabsViewMode;
        })

        /*for (let prop in this.tabs){
            if (!this.tabsViewMode && tabId && this.tabs[prop].id === tabId){
                this.tabs[prop].isActive = true;
            } else{
                this.tabs[prop].isActive = this.tabsViewMode;
            }
            this.tabs[prop].viewMode = this.tabsViewMode;
        }*/

        if (this.lastActiveTabId && !this.tabsViewMode){
            this.tabHeaders.some(t => t.isActive = t.id === this.lastActiveTabId)
        } else if (!tabId && !this.tabsViewMode && this.tabHeaders.length){
            this.tabHeaders[0].isActive = true;
        }
        this.helper.wait(() => this.dataExchange.notifyTabsResize(this.sharedGUID), 5);
        this.syncModes();
        //this.dataExchange.notifyTabsResize();
        // if (this.tabsViewMode){
        //
        // } else {
        //     for (let prop in this.tabs){
        //         this.tabs[prop].isActive = true;
        //     };
        // }

        // console.log('notifyTabsResize')
    }

    //# change tabs display mode
    public toggleTabDisplayMode = (): void =>{

        this.tabsDisplayMode = !this.tabsDisplayMode;
        if (this.tabsDisplayMode && this.compareChartArr.length){
            this.compareChartArr.length = 0;
        }

        // if (this.tabsDisplayMode && this.chartsHeightCoeff === 1){
        //     this.chartsHeightCoeff = 0.6;
        // }

        // if (this.tabsDisplayMode){
        //     this.tabsWidthCoeff.tw = 100;
        //     this.tabsWidthCoeff.cw = 100;
        // } else{
        //     this.tabsWidthCoeff = JSON.parse(localStorage['BgChartsWidthCoeff'])
        // }

        const updateAllTabDisplayMode = (): void =>{
            for (let prop in this.tabs){
                this.tabs[prop].displayMode = this.tabsDisplayMode;
            }
        };

        this.tabsDisplayMode ? this.helper.wait(updateAllTabDisplayMode, 1000) : updateAllTabDisplayMode();

        // this.tabsDisplayMode ? this.setChartsHeight() : this.setChartsWidth();
        //
        this.setChartsHeight();
        this.setChartsWidth();
        this.helper.wait(() => this.dataExchange.notifyTabsResize(this.sharedGUID), 5);
        this.helper.wait(() => this.dataExchange.updateChartDimensions(this.sharedGUID), 500);
        this.syncModes();
    }

    //# toggle chart visibility
    public toggleChartVisibility = (): void =>{
        this.hideChart = !this.hideChart;

        this.tabsDisplayMode ? this.setChartsHeight() : this.setChartsWidth();

        this.syncModes();
        this.helper.wait(() => this.dataExchange.notifyTabsResize(this.sharedGUID), 5);
    }

    //# get tab by ID
    private getTabComponent = (tabId: string): any =>{
        switch (tabId){
            case 'IOH':
                return this.IOH;
            case 'BCH':
                return this.BCH;
            case 'IA':
                return this.IA;
            case 'BCR':
                return this.BCR;
            case 'SSS':
                return this.SSS;
            case 'AST':
                return this.AST;
            case 'CD':
                return this.CD;
            default:
                return null;
        }
    }

    //# get tab data for excel from all opened tabs
    private getDataExcelViewMode = (): any[] =>{
        let excelDataList: any[] = [];
        console.log(this.tabsEls, 'getDataExcelViewMode')
        this.tabsEls.forEach((item) =>{
            if (item.tab.id === 'AST'){
                return;
            }
            let excelData: any = item.getExportData();

            for (let prop in excelData){
                let found = prop.match(/[\w\-]+Row/);
                if (found){
                    // console.log(item, prop, 'SheetName')
                    excelData[`${prop}SheetName`] = item[`${prop}SheetName`];
                }
            }
            excelData.sku = this.mainChartData.itemInfo.sku;
            excelData.warehouseCode = this.mainChartData.itemInfo.warehouseCode;
            excelData.culture = moment.locale();
            excelDataList.push(excelData);
        });

        /*this.tabHeaders.forEach((item) =>{
            if (item.id === 'AST'){
                return;
            }
            //TODO remake for get components dynamically
            let tabComponent: any = this.getTabComponent(item.id),
            // let tabComponent: any = this.tabHeaders.find(inItem => inItem.id === item.id),
                excelData: any = tabComponent.getExportData();
            // sheetNames: string[] = [];

            for (let prop in excelData){
                let found = prop.match(/[\w\-]+Row/);
                if (found){
                    excelData[`${prop}SheetName`] = tabComponent[`${prop}SheetName`];
                }
            }
            excelData.sku = this.mainChartData.itemInfo.sku;
            excelData.warehouseCode = this.mainChartData.itemInfo.warehouseCode;
            excelData.culture = moment.locale();
            excelDataList.push(excelData);
        });*/

        // console.log(excelDataList, 'excelDataList')
        return excelDataList
    }

    //# save all opened tabs in excel
    public saveExcelViewMode = (): void =>{
        if (this.tabsViewMode){
            let excelDataList: any[] = this.getDataExcelViewMode();

            this.graphService.downloadViewMode(excelDataList).subscribe((data: Blob | { message: string }) =>{
                    if (data && (data as Blob).size > 0){
                        this.translateService.get('Tabs_Report').subscribe(t =>{
                            fileSaver.saveAs(data, t);
                        })
                    } else{
                        data && (data as { message: string }).message ?
                            this.translateService.get((data as { message: string }).message).subscribe(error =>{
                                this.commonData.showErrors([error]);
                            }) :
                            this.translateService.get('GenerateReportError').subscribe(error =>{
                                this.commonData.showErrors([error]);
                            })
                    }

                }, e =>{
                    this.helper.showError(e, () => this.commonData.showErrors([e.message || e]));
                }
            )
        } else {
            (this.tabsEls as any[]).some(tab => {
                if (tab.isActive){
                    tab.onDownloadClick();
                    return true;
                }
            })
        }
    }

    //# send to email all opened tabs in excel
    public sendExcelViewMode = (): void =>{
        if (this.tabsViewMode){
            let excelDataList: any[] = this.getDataExcelViewMode();

            this.graphService.sendViewMode(excelDataList).subscribe((data: { accessDenied: boolean, success: boolean, message: string }) =>{

                    if (!data || !data.success){
                        this.commonData.showLoadingImg = false;
                        this.translateService.get(data && data.accessDenied ? 'AccessDenied' : 'SendReportError')
                            .subscribe(error => this.commonData.showErrors([error]));
                        return;
                    }
                    this.commonData.showInfo([data.message], null);
                },
                e =>{
                    this.helper.showError(e, () => this.commonData.showErrors([e.message || e]));
                });
        } else {
            (this.tabsEls as any[]).some(tab => {
                if (tab.isActive){
                    tab.onSendClick();
                    return true;
                }
            })
        }
    }

    public showTabsListFunc = (horizontalList: boolean): void =>{
        // if (!this.showTabsList) {
        //     this.showTabsList = true
        // }
        horizontalList ? this.showTabsListHor = !this.showTabsListHor : this.showTabsList = !this.showTabsList;
    }

    //# toggle tabs list visibility, in header
    public showTabsListFuncHdr = (): void =>{
        // if (!this.showTabsList) {
        //     this.showTabsList = true
        // }
        this.showTabsListHdr = !this.showTabsListHdr;
    }

    //# change display mode in stocks module
    public toggleOuterDisplayMode = (): void =>{
        this.outerDisplayMode = !this.outerDisplayMode;
        this.outerDisplayModeOutput.emit(this.outerDisplayMode)
    }

    //# update data in tabs
    private updateTabs = (dataModel: ChartSetDataModel): void =>{
        if (!dataModel || dataModel.GUID !== this.GUID){
            return;
        }
        this.getCompareData();
        this.dataExchange.setChartData(new ChartDataGUID(this.GUID, dataModel.data, dataModel.summaryData));
        this.removeAllTabs(false);
        this.toggleTabs();
    }

    //# toggle info chart info visibility
    public toggleInfoShow = (): void =>{
        this.dataExchange.setToggleChartInfo({type: this.type, sharedGUID: this.sharedGUID, show: !this.showInfo});
        this.compareButtonsPopperUpdate = true;
        // this.customListsPopperCreate = true;
        // this.showInfo = !this.showInfo;
    }

    //# save modes to service
    private syncModes = (): void =>{
        this.dataExchange.setTabsMode(new TabsModeGUID(this.sharedGUID, this.tabsViewMode, this.tabsDisplayMode, this.isTabsVisible))
        this.dataExchange.setChartVisibility(new ChartVisibilityGUID(this.sharedGUID, this.hideChart))
    }

    //# add popper to compare custom chart form
    public popperAdd = (): void =>{
        if (!this.customListBtn || !this.customListsWrp){
            return;
        }

        this.customListsPopper = new Popper(this.customListBtn.nativeElement, this.customListsWrp.nativeElement, {
            placement: 'bottom-end',
            modifiers: {
                flip: {
                    behavior: ['bottom-end']
                },
                preventOverflow: {
                    boundariesElement: this.mainWrp.nativeElement,
                },
            },
        });
    };

    //# add popper for chart compare buttons wrapper
    public comparePopperAdd = (): void =>{
        this.compareButtonsPopper = new Popper(this.showCompBtn.nativeElement, this.btnWrpCompare.nativeElement, {
            placement: 'bottom-end',
            modifiers: {
                flip: {
                    behavior: ['bottom-end']
                },
                preventOverflow: {
                    boundariesElement: this.mainWrp.nativeElement,
                },
            },
        });
    };

    //# add compare chart
    public addCompareChart = (itemId: number): void =>{
        let newChart = new AddChartModel(itemId, this.helper.generateGUID(), this.sharedGUID, this.type);
        newChart = this.setToNewChartDates(newChart);
        // console.error('addCompareChart')
        this.dataExchange.setAddChart(newChart);
        this.showCustomLists = false;
        this.hideCompareBtn = true;
    };

    //# add dates from period selector to compare chart
    private setToNewChartDates = (newChart: AddChartModel): AddChartModel =>{
        newChart.startDate = this.chartPeriodSelector.startDate;
        newChart.endDate = this.chartPeriodSelector.endDate;
        return newChart;
    };

    //# updates popper add compare chart form
    public popperUpd = (): void =>{
        this.compareButtonsPopper ? this.compareButtonsPopper.update() : null;
        this.customListsPopper.update();
    };

    //# show custom chart add form
    public showCustomList = (): void =>{
        // console.log('showCustomList');
        if (this.showCustomLists){
            this.customListsPopper.destroy();
            this.customListsPopper = null;
            this.showCustomLists = false;
        } else{
            this.showCustomLists = true;
            this.customListsPopperCreate = true;
        }
    };

    public showWrhListFunc = (): void =>{
        if (!this.showWrhList){
            this.showWrhList = true;
        }
        this.showCustomLists = false;
    };

    //# create filter for custom add chart form
    private addToListProps = (GUID?: string): void =>{
        let chartListProps: ChartListProps[] = this.dataExchange.getChartListProps(),
            filter = new StocksFilter();
        if (!GUID){
            filter.skus = [this.mainChartData.itemInfo.sku];
            filter.warehouses = [this.mainChartData.itemInfo.warehouseCode];
        }

        chartListProps.push(new ChartListProps(GUID ? GUID : this.GUID, filter));
        this.dataExchange.setChartListProps(chartListProps);
    };

    //# hide add chart form in we click not in form
    private hideAddChart = (e: MouseEvent): void =>{
        if (this.showCustomLists && this.helper.hideList(this.customListBtn, e, this.renderer)){
            this.helper.wait(() => this.showCustomLists = false, 200);
        }
    };

    //# hide compare form in we click not in form
    private hideAddCompareChartBtns = (e: MouseEvent): void =>{
        if (this.hideCompareBtn === false && this.helper.hideList(this.btnWrpCompare, e, this.renderer)){
            this.helper.wait(() => this.hideCompareBtn = true, 300);
        }
    };

    //# update universal tab views
    private updateUniversalTabs = (): void =>{
        this.simpleTab.length = 0;
        this.tabHeaders.forEach(item => item.type === 'SimpleTab' ? this.simpleTab.push(item) : null)
    }

    public changeCustomRowHeightState = (tab: ITabInfo, state: boolean): void =>{
        // console.log(this.tabsEls, tab, 'changeCustomRowHeightState');
        (this.tabsEls as any[]).some(t => {
            if (t.tab.id === tab.id){
                t.setCustomRowHeightState(state);
                return true;
            }
        })
    }

    //# toggle show bubble chart on main and compare chart
    public toggleBubbleShow = (): void => {
        this.dataExchange.setToggleBubbleChart({
            type: this.type,
            sharedGUID: this.sharedGUID,
            show: !this.bubbleVisible
        });
    };

    public readonly getTabHeightClass = (): number => {
        if (this.tabsWrp && this.tabsWrp.nativeElement && this.tabsWrp.nativeElement.offsetHeight > this.tabHeaders.length * 300 && this.tabsViewMode){
            return
        } else {
            return 0
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/buffer-graph.component/buffer-graph.component.ts